import {Button} from "reactstrap";

function PlanCard(props) {
    return (
        <>
            <div className="col-xl-4 col-md-12">
                <div className="card card-pricing">
                    <div className="card-body text-center">
                        <p className="card-pricing-plan-name font-weight-bold text-uppercase">{props.plan.name}</p>
                        <span className="card-pricing-icon text-primary">
                            <i className={props.plan.plan_icon}/>
                        </span>
                        <h2 className="card-pricing-price">INR {props.plan.price} <span>{props.plan.billing_cycle}</span></h2>
                        <ul className="card-pricing-features">
                            <li>Products Supported - {props.plan.product_supported}</li>
                            <li>Price Per Product - INR {props.plan.per_product_rate}</li>
                            <li>Staffs Supported - {props.plan.staff_supported}</li>
                            <li>Price Per Staff - INR {props.plan.per_staff_rate}</li>
                            <li>Transaction Fee - {props.plan.transaction_fee}%</li>
                            <li>Multiple Image per Product - {props.plan.is_multiple_image_uploads_supported? "Yes": "No"}</li>
                            <li>Add On Product Support - {props.plan.is_add_on_product_supported? "Yes": "No"}</li>
                            <li>Product Group Support - {props.plan.is_product_group_supported? "Yes": "No"}</li>
                            <li>VIP Customer - {props.plan.is_vip_customer_supported? "Yes": "No"}</li>
                            <li>International Payment acceptance - {props.plan.is_international_payments_accepted? "Yes": "No"}</li>
                            <li>AI Powered Analytics - {props.plan.is_ai_powered_analytics_supported? "Yes": "No"}</li>
                            <li>Refunds Allowed - {props.plan.is_refund_supported? "Yes": "No"}</li>
                            <li>Multi Language Support - {props.plan.is_multi_language_supported? "Yes": "No"}</li>
                            <li>Free UPI Transaction - {props.plan.is_upi_transaction_free? "Yes": "No"}</li>
                            <li>Free Cash Transaction - {props.plan.is_cash_transaction_free? "Yes": "No"}</li>
                            <li>Customizable Invoice - {props.plan.is_invoice_customizable? "Yes": "No"}</li>
                            <li>Transactional Email and SMS Support - {props.plan.is_transactional_email_sms_supported? "Yes": "No"}</li>
                            <li>SMS Charges - INR {props.plan.sms_charge_rate}/SMS</li>
                            <li>Email Charges - INR {props.plan.email_charge_rate}/Email</li>
                            <li>Relationship Manager - {props.plan.is_relationship_manager_available? "Yes": "No"}</li>
                            <li>API Access - {props.plan.is_api_access? "Yes": "No"}</li>
                            <li>Technical Support - {props.plan.technical_support}</li>
                            <li>Reward Rate - {props.plan.reward_rate}X</li>
                            <li>Monthly Free Credits - {props.plan.monthly_free_credits}</li>
                            <li>Data Retention - {props.plan.data_retention===null? "UNLIMITED": props.plan.data_retention} Months</li>

                        </ul>
                        <Button className="btn btn-primary waves-effect waves-light mt-4 btn-block">Sign Up</Button>
                    </div>
                </div>

            </div>
        </>
    );
}

export default PlanCard;